import React from 'react';

interface CheckIconProps {
  width?: number,
  height?: number
}

const CheckIcon = ({width = 14, height = 14}: CheckIconProps) => {

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 14 14`}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3251 3.88742C11.7807 4.34304 11.7807 5.08173 11.3251 5.53734L6.85002 10.0124C6.39441 10.468 5.65572 10.468 5.20011 10.0124L2.57511 7.38743C2.1195 6.93182 2.1195 6.19312 2.57511 5.73751C3.03072 5.2819 3.76941 5.2819 4.22502 5.73751L6.02507 7.53756L9.67519 3.88742C10.1308 3.43181 10.8695 3.43181 11.3251 3.88742Z"
        fill="#3ACE85"
      />
    </svg>
  );
};

export default CheckIcon;